import { Suspense } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { notification, Spin } from 'antd';
import { HomeRoutes } from '@project/routes/HomeRoutes';
import { MapRoutes } from '@project/routes/MapRoutes';
import { NotFoundRoutes } from '@project/routes/NotFound';
import { PrintCard } from '@project/routes/PrintCard';
import { reaction } from 'mobx';
import { AdminRoutes } from './AdminRoutes';
import { PATH } from './constants/paths';
import { store } from '@project/store';
import MapWidget from './pages/MapWidget/v1';
import { MainLayout } from './MainLayout';
import { ScrollToAnchor } from '@project/routes/ScrollToAnchor';

reaction(
  () => store.initLayers.error,
  (error) => {
    if (!error) return;

    notification.error({
      title: store.initLayers.error,
    });
  },
);

export const Router = () => {
  return (
    <HashRouter>
      <ScrollToAnchor />
      <Suspense
        fallback={
          <div className="spin">
            <Spin size="large" />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HomeRoutes />} />
            <Route path={`${PATH.MAP}/*`} element={<MapRoutes />} />
            <Route path={`${PATH.ADMIN}/*`} element={<AdminRoutes />} />
            <Route path={`${PATH.PRINT}/*`} element={<PrintCard />} />
            <Route path="*" element={<NotFoundRoutes />} />
          </Route>

          <Route path={PATH.MAP_WIDGET_V1} element={<MapWidget />} />
          <Route path="*" element={<NotFoundRoutes />} />
        </Routes>
      </Suspense>
    </HashRouter>
  );
};
